import React from 'react';
import PropTypes from 'prop-types';

import Config from '@/config';

const EmbedCode = ({ form_engine }) => {
  return (
    <div>
      <p style={{ fontFamily: 'monospace', lineHeight: '1.8em', fontSize: '12px' }}>
        {`<link href='${Config.FORM_ENGINE_URL}@css/reset.css' rel='stylesheet' type='text/css'>`}
        <br />
        {"<script type='text/javascript'>"}
        <br />
        <span style={{ marginLeft: '20px' }}>
          {`window.IXN_FORMS_ENGINE_CONFIG = { id: '${form_engine.guid}' };`}
        </span>
        <br />
        {'</script>'}
        <br />
        {"<div id='ixn-forms-engine'></div>"}
        <br />
        {`<script type='text/javascript' src='${Config.FORM_ENGINE_URL}js/forms_engine.widget.js'></script>`}
      </p>
    </div>
  );
};

EmbedCode.propTypes = {
  form_engine: PropTypes.object
};

export default EmbedCode;
